module.exports = __webpack_public_path__ + "img/notifications.6f0a3e25.jpg";